﻿(function () {
  function ready(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback);
      return;
    }

    callback();
  }

  function clean(value) {
    return String(value || '').trim();
  }

  function buildQuery(width, height, rim) {
    return width + '/' + height + ' ' + rim;
  }

  function initDropdown(header, options) {
    var toggles = Array.from(document.querySelectorAll(options.toggle));
    var toggle = toggles.find(function (item) {
      return header.contains(item);
    }) || toggles[0];
    var finder = header.querySelector(options.finder);

    if (!toggle || !finder) {
      return;
    }

    var close = header.querySelector(options.close);
    var firstField = header.querySelector(options.firstField);

    function setOpen(isOpen) {
      var oppositeFinder = options.oppositeFinder ? header.querySelector(options.oppositeFinder) : null;
      var oppositeToggle = options.oppositeToggle ? header.querySelector(options.oppositeToggle) : null;

      if (isOpen && oppositeFinder && oppositeToggle) {
        oppositeFinder.hidden = true;
        document.querySelectorAll(options.oppositeToggle).forEach(function (item) {
          item.setAttribute('aria-expanded', 'false');
        });
        header.setAttribute(options.oppositeState, 'false');
      }

      finder.hidden = !isOpen;
      toggles.forEach(function (item) {
        item.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
      header.setAttribute(options.state, isOpen ? 'true' : 'false');

      if (isOpen && firstField) {
        finder.scrollIntoView({ block: 'nearest' });
        window.setTimeout(function () {
          firstField.focus();
        }, 0);
      }
    }

    toggles.forEach(function (item) {
      item.addEventListener('click', function () {
        setOpen(finder.hidden);
      });
    });

    if (close) {
      close.addEventListener('click', function () {
        setOpen(false);
        toggle.focus();
      });
    }

    document.addEventListener('click', function (event) {
      var clickedToggle = event.target && typeof event.target.closest === 'function' && event.target.closest(options.toggle);
      if (finder.hidden || header.contains(event.target) || clickedToggle) {
        return;
      }

      setOpen(false);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !finder.hidden) {
        setOpen(false);
        toggle.focus();
      }
    });
  }

  function initSearchShortcut(header) {
    var input = header.querySelector('.p4m-header-search__input');
    if (!input) return;

    function focusedSearchFallbackUrl() {
      var params = new URLSearchParams();
      params.set('type', 'product');
      params.set('options[prefix]', 'last');
      params.set('options[fields]', 'title,body,tag,product_type,vendor,variants.sku,variants.title');
      return '/search?' + params.toString();
    }

    function isVisibleField(field) {
      if (!field) return false;
      var rect = field.getBoundingClientRect();
      var styles = window.getComputedStyle(field);
      return rect.width > 0 && rect.height > 0 && styles.visibility !== 'hidden' && styles.display !== 'none';
    }

    document.querySelectorAll('[data-p4m-mobile-search]').forEach(function (button) {
      button.addEventListener('click', function () {
        var bikeFinder = header.querySelector('[data-p4m-bike-finder]');
        var tireFinder = header.querySelector('[data-p4m-tire-finder]');
        if (bikeFinder) bikeFinder.hidden = true;
        if (tireFinder) tireFinder.hidden = true;
        header.setAttribute('data-bike-open', 'false');
        header.setAttribute('data-tire-open', 'false');
        document.querySelectorAll('[data-p4m-bike-toggle], [data-p4m-tire-toggle]').forEach(function (toggle) {
          toggle.setAttribute('aria-expanded', 'false');
        });

        if (!isVisibleField(input)) {
          window.location.href = focusedSearchFallbackUrl();
          return;
        }

        try {
          input.focus({ preventScroll: true });
        } catch (_error) {
          input.focus();
        }

        input.scrollIntoView({ block: 'center' });
        window.setTimeout(function () {
          if (document.activeElement !== input) {
            window.location.href = focusedSearchFallbackUrl();
          }
        }, 120);
      });
    });
  }

  function initTireFinder(header) {
    var form = header.querySelector('[data-p4m-tire-form]');

    if (!form) {
      return;
    }

    var width = header.querySelector('[data-p4m-tire-width]');
    var height = header.querySelector('[data-p4m-tire-height]');
    var rim = header.querySelector('[data-p4m-tire-rim]');
    var query = header.querySelector('[data-p4m-tire-query]');

    form.addEventListener('submit', function () {
      var selectedWidth = clean(width && width.value);
      var selectedHeight = clean(height && height.value);
      var selectedRim = clean(rim && rim.value);

      if (!selectedWidth || !selectedHeight || !selectedRim) {
        return;
      }

      if (query) {
        query.value = buildQuery(selectedWidth, selectedHeight, selectedRim);
      }
    });
  }

  ready(function () {
    document.querySelectorAll('[data-p4m-retail-header]').forEach(function (header) {
      initDropdown(header, {
        toggle: '[data-p4m-bike-toggle]',
        finder: '[data-p4m-bike-finder]',
        close: '[data-p4m-bike-close]',
        firstField: '[data-p4m-category]',
        state: 'data-bike-open',
        oppositeToggle: '[data-p4m-tire-toggle]',
        oppositeFinder: '[data-p4m-tire-finder]',
        oppositeState: 'data-tire-open',
      });

      initDropdown(header, {
        toggle: '[data-p4m-tire-toggle]',
        finder: '[data-p4m-tire-finder]',
        close: '[data-p4m-tire-close]',
        firstField: '[data-p4m-tire-width]',
        state: 'data-tire-open',
        oppositeToggle: '[data-p4m-bike-toggle]',
        oppositeFinder: '[data-p4m-bike-finder]',
        oppositeState: 'data-bike-open',
      });

      initTireFinder(header);
      initSearchShortcut(header);
    });
  });
})();
